import { Grid as MuiGrid } from '@mui/material';
import { styled } from '@mui/material/styles';
import colors from '../../assets/colors';

const Grid = styled(MuiGrid, {
  shouldForwardProp: (prop) =>
    prop !== 'topMargin' &&
    prop !== 'backgroundImage' &&
    prop !== 'image' &&
    prop !== 'infoCard',
})(({ theme, topMargin, backgroundImage, image, infoCard }) => ({
  ...(topMargin && {
    marginTop: '2%',
  }),
  ...(backgroundImage && {
    backgroundImage: `url(${image})`,
    backgroundRepeat: 'no-repeat',

    backgroundColor:
      theme.palette.type === 'light'
        ? theme.palette.grey[50]
        : theme.palette.grey[900],

    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }),
  ...(infoCard && {
    backgroundColor: colors.oldAgroweGreen,
    color: colors.white,
    margin: '2vh',
    textAlign: 'center',
    overflowWrap: 'anywhere',
    hyphens: 'auto',
    paddingLeft: 5,
    paddingRight: 5,
  }),
}));

export default Grid;
